
export const monCompteCommandeMagasinOverviewProps = () => ({
  commande: {
    type: Object,
    required: true
  }
})

export const useMonCompteCommandeMagasinOverview = (props) => {
  const commandeListReversed = computed(() => {
    return props.commande.attributes.tickets_de_caisse.slice().reverse()
  });

  const ouvrirPdf = (url) => {
    window.open(url, "_blank")
  };

  return { commandeListReversed, ouvrirPdf }
}